import InsertInvitationIcon from '@mui/icons-material/InsertInvitation'
import classNames from 'classnames'
import moment from 'moment'
import React from 'react'
import { DayPicker, ModifiersStyles } from 'react-day-picker'
import { fi } from 'react-day-picker/locale'
import { i18n } from '../../domain/index'
import css from './dateField.css'

// eslint-disable-next-line import/no-unresolved
import '!style-loader!css-loader!react-day-picker/style.css'

type Props = {
  value: string
  label?: string
  labelOnTop: boolean
  onChange?: (...props: any) => any
  modifiers?: any
}

type State = {
  date: string
  open: boolean
}

const modifiersStyles: ModifiersStyles = {
  container: {
    position: 'absolute',
    top: 0,
    bottom: 0,
  },
}

const DATE_FORMAT = 'YYYY-MM-DD'

class DateField extends React.Component<Props, State> {
  node: any

  static defaultProps = {
    labelOnTop: false,
    modifiers: {},
  }

  constructor(props: Props) {
    super(props)

    this.state = {
      date: props.value || moment().format(DATE_FORMAT),
      open: false,
    }
  }

  UNSAFE_componentWillMount() {
    //TODO: rewrite outdated and unsafe life circle hooks
    document.addEventListener('mousedown', this.handleClick, false)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick, false)
  }

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    // Update state date if value changes in props.
    if (nextProps.value !== this.state.date) {
      this.setState({ date: nextProps.value })
    }
  }

  handleClick = (e: any) => {
    if (this.node?.contains(e.target)) {
      return
    }

    this.setState({
      open: false,
    })
  }

  getFieldValue = () => {
    return moment(this.state.date).format('D.M.YYYY')
  }

  onDayClick = (date: Date) => {
    const formattedDate = moment(date).format(DATE_FORMAT)
    this.setState({
      date: formattedDate,
      open: false,
    })

    if (typeof this.props.onChange === 'function') {
      this.props.onChange(formattedDate)
    }
  }

  onFieldClick = () => {
    this.setState({
      open: !this.state.open,
    })
  }
  closePicker = () => {
    this.setState({ open: false })
  }

  stopPropagation = (e: React.MouseEvent) => {
    e.stopPropagation()
  }

  render() {
    const { modifiers, label, labelOnTop } = this.props
    const { open } = this.state
    const isLabelShown = !!label || typeof label === 'undefined'
    const selectedDate = moment(this.state.date).toDate()
    return (
      <div className={classNames(css.component, { [css.labelOnTop]: labelOnTop })} ref={(node) => (this.node = node)}>
        <div className={css.field} onClick={this.onFieldClick}>
          {isLabelShown && <div className={css.label}>{label || i18n.t('dateField.defaultLabel')}:</div>}
          <div className={css.input}>{this.getFieldValue()}</div>
          <InsertInvitationIcon className={css.icon} />
        </div>
        {open && (
          <div className={classNames(css.pickerContainer, css.open)} onClick={this.closePicker}>
            <div className={css.picker} onClick={this.stopPropagation}>
              <DayPicker
                showWeekNumber
                showOutsideDays
                required
                mode='single'
                onDayClick={this.onDayClick}
                selected={selectedDate}
                locale={fi}
                weekStartsOn={1}
                modifiers={modifiers}
                modifiersStyles={modifiersStyles}
              />
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default DateField
